import { render } from "./PropertiesXAxisNumber.vue?vue&type=template&id=3ad3578c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__